export const UPDATE_PRODUCT_HISTORY = 'productHistory/UPDATE_PRODUCT_HISTORY'
export const UPDATE_PRODUCT_HISTORY_ID_LIST = 'productHistory/UPDATE_PRODUCT_HISTORY_ID_LIST'
export const UPDATE_PRODUCT_HISTORY_CATEGORIES = 'productHistory/UPDATE_PRODUCT_HISTORY_CATEGORIES'
export const UPDATE_PRODUCT_HISTORY_CATEGORY_ID_LIST = 'productHistory/UPDATE_PRODUCT_HISTORY_CATEGORY_ID_LIST'
export const UPDATE_SELECTED_PRODUCT_HISTORY_ID = 'productHistory/UPDATE_SELECTED_PRODUCT_HISTORY_ID'
export const UPDATE_SELECTED_PRODUCT_HISTORY_CATEGORY_ID = 'productHistory/UPDATE_SELECTED_PRODUCT_HISTORY_CATEGORY_ID'



